import React from 'react';
import PropTypes from 'prop-types';

export default function HuntUnitsIcon({ color = '#ffffff', width = 20, height = 20 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={width} height={height} fill={color}>
      <path d="M426.7 64c11.8 0 21.3 9.6 21.3 21.3V426.7c0 11.8-9.6 21.3-21.3 21.3H85.3C73.6 448 64 438.4 64 426.7V85.3C64 73.6 73.6 64 85.3 64H426.7zm-188 216.7L106.7 304V405.3h154l-22-124.6h0zm166.6-174h-154L304 405.3H405.3V106.7zm-197.3 0H106.7v154l124.6-22L208 106.7z" />
    </svg>);
}

HuntUnitsIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
